import { render, staticRenderFns } from "./RegisterTerms.vue?vue&type=template&id=5e13d64a&scoped=true&"
import script from "./RegisterTerms.vue?vue&type=script&lang=js&"
export * from "./RegisterTerms.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTerms.vue?vue&type=style&index=0&id=5e13d64a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13d64a",
  null
  
)

export default component.exports